/// <amd-module name="Artifacts/Connect/types/ITool" />

import { PackagingService, TfsService } from "Artifacts/Connect/services/PackagingService";
import { ICombinedFeedView } from "Artifacts/Connect/types/ICombinedFeedView";
import { IProtocol } from "Artifacts/Connect/types/IProtocol";
import * as React from "react";
import { IVssPageContext } from "VSS/Platform/Context";
import { IPageData } from "VSS/Platform/Page";
import { IAnchorProps } from "VSSUI/Link";

export interface ITool {
  /**
   * Tool ID.
   */
  readonly id: ToolId;

  /**
   * Tool name.
   */
  readonly name: string;

  /**
   * Tool protocol.
   */
  readonly protocol: IProtocol;

  /**
   *
   */
  readonly allowNonMembers: boolean;

  /**
   * Path to the tool icon (logo).
   */
  readonly imagePath: string;

  /**
   * Component rendered on tool selection.
   */
  readonly Component: React.ComponentType;

  /**
   * isEnvironmentSupported checks whether given tool is available`
   * in current deployment.
   * @param pageData VSS page data object.
   */
  isEnvironmentSupported(pageData: IPageData): boolean;

  supportsGet(): boolean;

  supportsPush(feed: ICombinedFeedView): boolean;

  /**
   * renderComponent prepares component props and necessary metadata to render Component element.
   * @param pageContext VSS page context.
   * @param feed information of feed + view combined
   * @param collectionName string
   * @param isUserMember boolean
   * @param isHosted boolean
   */
  renderComponent(
    pageContext: IVssPageContext,
    feed: ICombinedFeedView,
    packagingService: PackagingService,
    tfsService: TfsService,
  ): JSX.Element;

  /**
   * getToolLink renders the tool documentation for a certain tool and is optional
   */
  getToolLink?: () => IAnchorProps & { children?: React.ReactNode };

  isProtocolEnabled(pageContext: IVssPageContext): boolean;
}

export enum ToolId {
  DotNet,
  NuGet,
  VisualStudio,
  npm,
  Maven,
  Gradle,
  pip,
  twine,
  UniversalPackages,
  Cargo,
  Ivy,
  Conda,
}
